import React, { useEffect, useState } from "react";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import ButtonType from "../common/button/ButtonType";

interface IAlterationFormsListAddElementProps {
  onCreate: (name: string, type: string) => void;
}

function AlterationFormsListAddElement({
  onCreate,
}: IAlterationFormsListAddElementProps) {
  // set state for form info
  const [name, setName] = useState<string>("");
  // manage validation error messages
  const [nameValidationError, setNameValidationError] = useState("");

  // Handle saving the updated name
  const handleBlurOrEnter = (e?: React.KeyboardEvent<HTMLInputElement>) => {
    if (!e || e.key === "Enter") {
      if (!name || name.trim().length < 4) {
        setNameValidationError(
          "Name must be at least 4 characters long. Please try again."
        );
      } else {
        setNameValidationError("");
        onCreate(name, "alteration_form");
      }
    }
  };

  return (
    <div className="alteration-form-add">
      <div>
        <label htmlFor="alteration-form-name">
          Create a new Alteration Form
        </label>
        <input
          name="alteration-form-name"
          id="alteration-form-name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={handleBlurOrEnter}
        />
        <div>{nameValidationError}</div>
      </div>

      <Button
        label="Create"
        purpose={ButtonAction.CREATE}
        type={ButtonType.ICON}
        onClick={handleBlurOrEnter}
      />
    </div>
  );
}

export default AlterationFormsListAddElement;
